import { useBootstrap } from "../providers/BootstrapProvider";

/**
 * useContentBlocks — Phase 71 rewrite.
 *
 * Backed by the single blocking BootstrapProvider fetch instead of its
 * own secondary request. This eliminates the \"default text flashes
 * briefly before custom text swaps in\" bug entirely — the map is
 * resolved BEFORE first paint.
 *
 * Returned shape is unchanged for every existing <EditableText> call
 * site: `{ map, refresh }`.
 */
export const useContentBlocks = () => {
  const { content_blocks, refresh } = useBootstrap();
  return { map: content_blocks || {}, refresh };
};

/** Dispatches a change event so the provider re-maps instantly. */
export const dispatchContentBlockChange = (block_key, value) => {
  window.dispatchEvent(
    new CustomEvent("dhdh:content-block-changed", { detail: { block_key, value } })
  );
};

/** Resolve a single block_key with inline fallback. */
export const resolveBlock = (map, block_key, fallback) => {
  const v = (map || {})[block_key];
  return v && v.length > 0 ? v : fallback;
};
